// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"372dd2ce","453":"0d2601df","622":"ece23395","977":"c542fb57"}[chunkId] + ".chunk.js";
};